<template>
    <v-row align="center"
           justify="center">
        <v-col sm="7" class="pa-5">
            <h1>Datenschutzerklärung</h1><br>
            <p>Verantwortlicher im Sinne der Datenschutzgesetze, insbesondere der EU-Datenschutzgrundverordnung (DSGVO),
                ist:</p>
            <br>{{contact.name}}
            <br>{{contact.street}}
            <br>{{contact.city}}<br>
            <br>Telefon: <span class="reverse"><a target="_blank" :href="contact.fonLink">{{contact.fon}}</a></span>
            <br>E-Mail: <span class="reverse"><a target="_blank"
                                                 :href="contact.mailLink">{{contact.mail}}</a></span><br>
            <br>
            <h2>Ihre Betroffenenrechte</h2>
            <br>
            <p>Unter den angegebenen Kontaktdaten unseres Datenschutzbeauftragten können Sie jederzeit folgende Rechte
                ausüben:</p>

            <br>Auskunft über Ihre bei uns gespeicherten Daten und deren Verarbeitung (Art. 15 DSGVO),
            <br>Berichtigung unrichtiger personenbezogener Daten (Art. 16 DSGVO),
            <br>Löschung Ihrer bei uns gespeicherten Daten (Art. 17 DSGVO),
            <br>Einschränkung der Datenverarbeitung, sofern wir Ihre Daten aufgrund gesetzlicher Pflichten noch nicht
            löschen dürfen (Art. 18 DSGVO),
            <br>Widerspruch gegen die Verarbeitung Ihrer Daten bei uns (Art. 21 DSGVO) und Datenübertragbarkeit, sofern
            Sie in die Datenverarbeitung eingewilligt haben oder einen Vertrag mit uns abgeschlossen haben (Art. 20
            DSGVO).

            <p>Sofern Sie uns eine Einwilligung erteilt haben, können Sie diese jederzeit mit Wirkung für die Zukunft
                widerrufen.</p>
            <p>Sie können sich jederzeit mit einer Beschwerde an eine Aufsichtsbehörde wenden, z. B. an die zuständige
                Aufsichtsbehörde des Bundeslands Ihres Wohnsitzes oder an die für uns als verantwortliche Stelle
                zuständige Behörde.</p>
            <p>Eine Liste der Aufsichtsbehörden (für den nichtöffentlichen Bereich) mit Anschrift finden Sie <a
                    href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html"
                    target="_blank" rel="nofollow noopener">hier</a>.
            </p>
            <p></p>
            <h2>Erfassung allgemeiner Informationen beim Besuch unserer Website</h2>
            <h3>Art und Zweck der Verarbeitung:</h3>
            <p>Wenn Sie auf unsere Website zugreifen, d.h., wenn Sie sich nicht registrieren oder anderweitig
                Informationen übermitteln, werden automatisch Informationen allgemeiner Natur erfasst. Diese
                Informationen (Server-Logfiles) beinhalten etwa die Art des Webbrowsers, das verwendete Betriebssystem,
                den Domainnamen Ihres Internet-Service-Providers, Ihre IP-Adresse und ähnliches. </p>
            <p>Sie werden insbesondere zu folgenden Zwecken verarbeitet:</p>
            <ul>
                <li>Sicherstellung eines problemlosen Verbindungsaufbaus der Website,</li>
                <li>Sicherstellung einer reibungslosen Nutzung unserer Website,</li>
                <li>Auswertung der Systemsicherheit und -stabilität sowie</li>
                <li>zu weiteren administrativen Zwecken.</li>
            </ul>
            <p>Wir verwenden Ihre Daten nicht, um Rückschlüsse auf Ihre Person zu ziehen. Informationen dieser Art
                werden von uns ggfs. statistisch ausgewertet, um unseren Internetauftritt und die dahinterstehende
                Technik zu optimieren.</p>
            <h3>Rechtsgrundlage:</h3>
            <p>Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres berechtigten Interesses an
                der Verbesserung der Stabilität und Funktionalität unserer Website.</p>
            <h3>Empfänger:</h3>
            <p>Empfänger der Daten sind ggf. technische Dienstleister, die für den Betrieb und die Wartung unserer
                Webseite als Auftragsverarbeiter tätig werden.</p>
            <h3>Speicherdauer:</h3>
            <p>Die Daten werden gelöscht, sobald diese für den Zweck der Erhebung nicht mehr erforderlich sind. Dies ist
                für die Daten, die der Bereitstellung der Webseite dienen, grundsätzlich der Fall, wenn die jeweilige
                Sitzung beendet ist.</p>
            <h3>Bereitstellung vorgeschrieben oder erforderlich:</h3>
            <p>Die Bereitstellung der vorgenannten personenbezogenen Daten ist weder gesetzlich noch vertraglich
                vorgeschrieben. Ohne die IP-Adresse ist jedoch der Dienst und die Funktionsfähigkeit unserer Website
                nicht gewährleistet. Zudem können einzelne Dienste und Services nicht verfügbar oder eingeschränkt sein.
                Aus diesem Grund ist ein Widerspruch ausgeschlossen. </p>
            <p></p>
            <h2>Social Links</h2>
            <h3>Art und Zweck der Verarbeitung:</h3>
            <p>Wir bieten Ihnen auf unserer Webseite die Möglichkeit der Nutzung von sog. „Social-Media-Links“ an. Zum
                Schutze Ihrer Daten werden diese Buttons auf der Webseite lediglich als Grafik eingebunden, die eine
                Verlinkung auf die entsprechende Webseite des Anbieters enthält. Durch Anklicken der Grafik werden Sie
                somit zu den Diensten der jeweiligen Anbieter weitergeleitet. Erst dann werden Ihre Daten an die
                jeweiligen Anbieter gesendet. Sofern Sie die Grafik nicht anklicken, findet keinerlei Austausch zwischen
                Ihnen und den Anbietern der Social-Media-Buttons statt. Informationen über die Erhebung und Verwendung
                Ihrer Daten in den sozialen Netzwerken finden Sie in den jeweiligen Nutzungsbedingungen der
                entsprechenden Anbieter.</p>
            <p>Wir haben auf unserer Website die Social-Media-Links folgender Unternehmen eingebunden:</p>
            <p><strong>Xing:</strong> Soziales Netzwerk Dienstanbieter: XING AG, Dammtorstraße 29-32, 20354 Hamburg,
                Deutschland Website: <a href="https://www.xing.de" target="_blank">https://www.xing.de</a> <br>
                <a href="https://privacy.xing.com/de/datenschutzerklaerung" target="_blank">Datenschutzerklärung</a>
            </p>
            <p><strong>LinkedIn:</strong> Soziales Netzwerk Dienstanbieter: LinkedIn Ireland Unlimited Company Wilton
                Place, Dublin 2, Irland Website: <a href="https://de.linkedin.com" target="_blank">https://de.linkedin.com</a>
                <br><a href="https://www.linkedin.com/legal/privacy-policy?_l=de_DE"
                                             target="_blank">Datenschutzerklärung</a>
            </p>
            <p></p>
            <h2>SSL-Verschlüsselung</h2>
            <p>Um die Sicherheit Ihrer Daten bei der Übertragung zu schützen, verwenden wir dem aktuellen Stand der
                Technik entsprechende Verschlüsselungsverfahren (z. B. SSL) über HTTPS.</p>
            <p></p>
            <h2>Eingesetzte Auftragsverarbeiter</h2>
            <p>Folgende Organisationen, Unternehmen bzw. Personen wurden vom Betreiber dieser Website mit der
                Verarbeitung von Daten beauftragt:</p>
            <p>Strato AG</p>
            <p></p>
            <h2>Änderung unserer Datenschutzbestimmungen</h2>
            <p>Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen
                Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen,
                z.B. bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die neue
                Datenschutzerklärung.</p>
            <h2>Fragen an den Datenschutzbeauftragten</h2>
            <p>Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail oder wenden Sie sich direkt an
                die für den Datenschutz verantwortliche Person in unserer Organisation:</p>
            <p></p>
            <p><em>Die Datenschutzerklärung wurde mithilfe der activeMind AG erstellt, den Experten für <a
                    href="https://www.activemind.de/datenschutz/datenschutzbeauftragter/" target="_blank"
                    rel="noopener">externe Datenschutzbeauftragte</a> (Version #2019-04-10).</em></p>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: "Datenschutz",
        props: {
            contactData: {
                type: Object,
            }
        },
        data: function () {
            return {
                contact: this.contactData
            }
        }
    }
</script>

<style>

    span.reverse {
        unicode-bidi: bidi-override;
        direction: rtl;
    }

    .page--datenschutz {
        background-color: #263238;
        background-image: url('~@/assets/bg/datenschutz.png');
        background-position: center center;
        -ms-background-size: cover;
        -o-background-size: cover;
        -moz-background-size: cover;
        -webkit-background-size: cover;
        background-size: cover;
    }
</style>
